import { render, staticRenderFns } from "./ESGPanel.vue?vue&type=template&id=b9d00ada"
import script from "./ESGPanel.vue?vue&type=script&lang=js"
export * from "./ESGPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports